import { UserResponseDto, UserResponseOfficeDto, UserResponseOfficeLocationDto } from '../user/index.js';
// ── Nested DTOs for auth-depth data ────────────────────────────────────
/**
 * Office location with billing-depth relations required by the auth flow.
 * Extends the lean identity DTO with payedFeatures, subscriptions, and
 * connected Stripe account information.
 */
export class AuthUserOfficeLocationDto extends UserResponseOfficeLocationDto {
    payedFeatures;
    subscriptions;
    connectedStripeAccountId;
    connectedStripeAccount;
}
/**
 * Office with the additional officeLocations list needed by ability rules.
 */
export class AuthUserOfficeDto extends UserResponseOfficeDto {
    officeLocations;
}
/**
 * Stripe customer record on the user — needed by billing checkout flows.
 */
export class AuthUserConnectedStripeCustomerDto {
    connectedStripeAccountId;
    stripeCustomerId;
}
// ── Main DTO ───────────────────────────────────────────────────────────
/**
 * Extended user DTO carrying auth-depth data.
 *
 * Populated once during authentication (HTTP guard / WebSocket handshake)
 * and attached to `AuthContext.user`. Contains all identity scalars from
 * {@link UserResponseDto} plus billing-owned relations that the auth flow,
 * guards, ability definitions, and billing checkout need at request time.
 */
export class AuthUserDto extends UserResponseDto {
    connectedStripeCustomers = [];
}
//# sourceMappingURL=auth-user.dto.js.map